import React, { useState } from "react";
import { Card, Dialog, DialogContent, Snackbar } from "@mui/material";
import { Container } from "@mui/system";
import Page from "../components/Page";
import FlujoCajaList from "../sections/@dashboard/flujo/FlujoCajaList";
import MuiAlert from "@mui/material/Alert";
import { useLazyQuery, useQuery } from "@apollo/client";
import { FLUJO_DE_CAJA } from "../graphql/bancos";
import { FlujoCajaHead } from "../sections/@dashboard/flujo";
const FlujoCaja = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [title, setTitle] = useState("");
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorGraph, setErrorGraph] = useState({
    severity: "",
    mensaje: "",
  });

  const { refetch } = useQuery(FLUJO_DE_CAJA); // Obtener refetch

  const [bodyDialog, setBodyDialog] = useState("");
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };
  return (
    <Page title="Flujo de Caja">
      <Container maxWidth="xl">
        <FlujoCajaHead
          setOpenDialog={setOpenDialog}
          setBodyDialog={setBodyDialog}
          setTitle={setTitle}
          setErrorGraph={setErrorGraph}
          setOpenSnackBar={setOpenSnackBar}
        />
        <Card>
          <FlujoCajaList
            setOpenDialog={setOpenDialog}
            setBodyDialog={setBodyDialog}
            setErrorGraph={setErrorGraph}
            setOpenSnackBar={setOpenSnackBar}
            refetch={refetch}
          />
        </Card>
      </Container>
      <Dialog open={openDialog}>
        <DialogContent>
          {" "}
          {React.cloneElement(bodyDialog, { refetch })}
          {/* Pasa refetch al formulario */}
        </DialogContent>
      </Dialog>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={errorGraph.severity}
          sx={{ width: "100%" }}
        >
          {errorGraph.mensaje}
        </Alert>
      </Snackbar>
    </Page>
  );
};
export default FlujoCaja;
